import { db } from '../firebase';
import firebase from 'firebase/app';

export async function getDuaSubcategories(categoryId) {
  let query = db.collection('dua_subcategories').orderBy('orderIndex');
  if (categoryId && categoryId !== 'all') {
    query = query.where('categoryId', '==', categoryId);
  }
  const snapshot = await query.get();
  return snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
}

export async function getAllDuaSubcategories() {
  const snapshot = await db.collection('dua_subcategories').orderBy('orderIndex').get();
  return snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
}

export async function createDuaSubcategory(data) {
  const maxOrder = await db.collection('dua_subcategories').orderBy('orderIndex', 'desc').limit(1).get();
  const orderIndex = maxOrder.empty ? 0 : (maxOrder.docs[0].data().orderIndex || 0) + 1;
  return db.collection('dua_subcategories').add({
    titleEn: data.titleEn || '',
    titleBn: data.titleBn || '',
    categoryId: data.categoryId,
    orderIndex,
    createdAt: firebase.firestore.FieldValue.serverTimestamp(),
    updatedAt: firebase.firestore.FieldValue.serverTimestamp(),
    created_at: firebase.firestore.FieldValue.serverTimestamp(),
    updated_at: "",
    deleted_at: "",
  });
}

export async function updateDuaSubcategory(id, data) {
  return db.collection('dua_subcategories').doc(id).update({
    titleEn: data.titleEn || '',
    titleBn: data.titleBn || '',
    categoryId: data.categoryId,
    updatedAt: firebase.firestore.FieldValue.serverTimestamp(),
    updated_at: firebase.firestore.FieldValue.serverTimestamp(),
  });
}

export async function deleteDuaSubcategory(id) {
  // Check if any Duas are referencing this subcategory
  const snapshot = await db.collection('duas')
    .where('subCategoryId', '==', id)
    .where('isDeleted', '==', false)
    .limit(1)
    .get();

  if (!snapshot.empty) {
    throw new Error('Cannot delete: This subcategory is currently in use by one or more Duas.');
  }

  return db.collection('dua_subcategories').doc(id).update({
    isDeleted: true,
    deletedAt: firebase.firestore.FieldValue.serverTimestamp(),
    updatedAt: firebase.firestore.FieldValue.serverTimestamp(),
    deleted_at: firebase.firestore.FieldValue.serverTimestamp()
  });
}
